import theme from '@/config/theme';
import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    paddingVertical: 20,
    paddingHorizontal: 32,
    borderRadius: 7,
    borderWidth: 1,
    borderStyle: 'solid',
    flexDirection: 'row',
    gap: 8,
    shadowColor: theme.colors.newUI.therapist.primaryBlue80,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.06,
    shadowRadius: 12,
    elevation: 3,
  },
  text: {
    fontSize: 16,
    fontWeight: 'bold',
  },
});
